import { fr } from "primelocale/js/fr.js";

const res = { ...fr };
res.dateFormat = "dd/mm/yy";
res.firstDayOfWeek = 1;
res.emptyMessage = "";

export default res;
